import { render, staticRenderFns } from "./visitor-menu.vue?vue&type=template&id=4a1a66ca&scoped=true"
import script from "./visitor-menu.vue?vue&type=script&lang=js"
export * from "./visitor-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1a66ca",
  null
  
)

export default component.exports